import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import custom from '@/f1/custom';
import { api } from '@/f1/service';
import codes from '@/f1/codes';
// import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';


const _i18n_data = {
  username: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};
export default {
  props: ['item', 'use_view'],
  components: { DatePicker, Language },
  data: () => { return { loading : false, codes, so : Object.assign({}, codes.DEFAULT_OPT, { sk : 'description', opt : {} }), custom } },
  computed: {
    i18n_data() { return _i18n_data },
    fields : function() {return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'created_at', label: 'Registed Date', sortable: false },
        { key: 'count', label: 'Using Site Count', sortable: false },
        { key: 'description', label: 'Description', sortable: false },
        { key: 'policy', label: 'Max Page', sortable: false },
        { key: 'updated_at', label: 'Last Modify', sortable: false },
        // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
    fields_ko : function() {return [
      { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
      { key: 'created_at', label: '등록일', sortable: false },
      { key: 'count', label: '사용중인 사이트', sortable: false },
      { key: 'description', label: '설명', sortable: false },
      { key: 'policy', label: '최대 페이지', sortable: false },
      { key: 'updated_at', label: '최근 수정일', sortable: false },
      // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
    ]
  },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['updated_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { sk : 'description', sv : '' }); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      if(this.loading) {
        return this.loading = false
      }
      this.loading = true
        let so = {
          target : 'policy', cmd : 'list',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.group) { so.body.and.push({ name : 'group_id', value : this.group.id, op : '='}) }
        if(this.so.sv && this.so.sk) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'updated_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'updated_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        }
      return api.wmds.WMDS(so).then(rs => { this.so.totalRows = rs.total; this.loading = false; return rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    detail: function(item) { this.use_view != false ? this.$router.push(`/wmds/policy/${item.id}`) : this.$parent.$emit('selected', item) },
  },
  created: function() {   console.log('policy.vue', 'created'); },
  destroyed: function() { console.log('policy.vue', 'destroyed'); },
  mounted: function() { console.log('policy.vue', 'mounted'); },
}
